import * as React from "react"

import Layout from "./layout"
import SEO from "./seo"
import { reducers } from "../data/redux-state"
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit"
import { Provider } from "react-redux"
import { MainUI } from "./MainUI"
import { LocationContext } from "../routes"
import { DomainRedirect } from "./DomainRedirect"

const customizedMiddleware = getDefaultMiddleware({
  serializableCheck: false,
})
export const globalStore = configureStore({
  reducer: reducers,
  devTools: true,
  middleware: customizedMiddleware,
})

let Index = ({ location }: { location: any }) => (
  <LocationContext.Provider value={location}>
    <DomainRedirect />
    <Provider store={globalStore}>
      <Layout>
        <SEO title="GCCI" />{" "}
        {/* This title should resolve to: "GCCI|Uni Graz Wegener Center" in combination with the title in gatsby-config.js */}
        <MainUI />
      </Layout>
    </Provider>
  </LocationContext.Provider>
)

export default Index
